import { http, prepareHttpQuery } from 'http';

export default {
  getAct: filters => http.post(`/flex/checkinout/dataFlexCheck${prepareHttpQuery(filters)}`),

  getTransferAct: filters =>
    http.post(`/flex/checkinoutTransfer/dataFlexCheck${prepareHttpQuery(filters)}`),

  cancelAct: (idTransaction, comment) =>
    http.post('/flex/checkinout/cancel', { idTransaction, comment }),

  cancelActTransfer: (idTransaction, comment) =>
    http.post('/flex/checkinoutTransfer/cancel', { idTransaction, comment }),

  validateDocument: data => http.post('/edoc/validate', data),

  endSign: payload => http.post(`/flex/checkinout/end`, payload),

  endSignTransfer: transactionId => http.post(`/flex/checkinoutTransfer/${transactionId}/end`),

  getDocuments: fileNames => http.post('/edoc/documents', { fileNames }),

  getDiscrepanciesFlexCheck: data => http.post('/flex/checkinout/discrepanciesFlexCheck', data)
};
